export class ImageService {
    constructor(storageUrl, storageBucket) {
        this.storageUrl = storageUrl;
        this.storageBucket = storageBucket;
    }
    /**
     * Creates a qualified url to the given source with the given options, e.g., dimensions.
     */
    format(src, options = null) {
        var _a, _b;
        if (!src) {
            return options && options.default ? options.default : null;
        }
        // There might be image objects where only the path exists -> treat as a string
        if (typeof src !== 'string') {
            const imageSource = src;
            if (imageSource.path && !imageSource.url) {
                src = imageSource.path;
            }
        }
        // If we have a plain image url, we can only do any modifications if hosted on our cdn, e.g., a relative path is specified
        if (typeof src === 'string') {
            const imageString = src;
            // If absolute or base image, we just use the whole url as the image src, otherwise we use our cdn
            if (imageString.startsWith('http') || imageString.startsWith('data:')) {
                return imageString;
            }
            const imagePath = imageString.startsWith('/') ? imageString : `/${imageString}`; // Make sure the path starts with '/'
            src = {
                url: this.storageUrl + imagePath,
                host: this.storageUrl,
                path: imagePath,
                is_default: false,
                customizable: true
            };
        }
        const imageSource = src;
        if (!imageSource.customizable || imageSource.url.indexOf('localhost') !== -1) {
            return imageSource.url;
        }
        let url = imageSource.host;
        // Apply the edits based on the specified options
        const edits = {};
        if (options !== null) {
            // Check for resize
            const width = options.width;
            const height = options.height;
            // If we do not have a set height or width, we keep the original proportions
            if (width || height) {
                edits.resize = {
                    fit: (_a = options.fit) !== null && _a !== void 0 ? _a : 'cover'
                };
                const backgroundColor = this.parseBackgroundColor((_b = options.background) !== null && _b !== void 0 ? _b : (options.fit === 'contain' ? 'transparent' : null));
                if (backgroundColor) {
                    edits.resize.background = backgroundColor;
                }
                if (width) {
                    edits.resize.width = Math.round(width);
                }
                if (height) {
                    edits.resize.height = Math.round(height);
                }
            }
            // Check for format
            if (options.format) {
                edits.toFormat = options.format;
            }
            // Check for blur
            if (options.blur) {
                edits.blur = { sigma: options.blur };
            }
        }
        // Specific extensions do not allow modifications, so we load them directly from the cdn without modifications
        if (imageSource.path.endsWith('.svg') || imageSource.path.endsWith('.gif')) {
            return `${url}${imageSource.path}`;
        }
        // For 'edits' options {@see https://sharp.pixelplumbing.com/}
        const imageRequest = JSON.stringify({
            bucket: this.storageBucket,
            key: imageSource.path.startsWith('/') ? imageSource.path.substr(1) : imageSource.path,
            edits: edits && Object.keys(edits).length ? edits : {}
        });
        const base64 = btoa(imageRequest);
        return `${url}/${base64}`;
    }
    /**
     * Parses the specified color to match the specifications of the Sharp resizer.
     * {@see https://sharp.pixelplumbing.com/api-resize#resize}
     *
     * @param color
     * @returns {{r: number, b: number, g: number, alpha: number}|string|null}
     */
    parseBackgroundColor(color) {
        if (!color) {
            return null;
        }
        if (color === 'transparent') {
            return { r: 0, g: 0, b: 0, alpha: 0 };
        }
        return color;
    }
}
//# sourceMappingURL=ImageService.js.map